(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', initMobileFooter);
  window.addEventListener('resize', function(){
    setTimeout(() => {
      initMobileFooter(); 
    }, 1);
  });
  async function initMobileFooter()
  {
    const isMobile = window.innerWidth < 768; 

    // Only run on small screens
    var toggles = document.querySelectorAll('.footer-toggle');

    toggles.forEach(function (toggle) {
      var targetMenu = document.getElementById('footer-menu-' + toggle.dataset.index);
        
      // Initially hide all
      if (targetMenu && isMobile) {
        targetMenu.style.display = 'none';
      }
      else if (!isMobile)
      {
        targetMenu.style.display = 'block';
      }

      if (isMobile)
      {
        toggle.addEventListener('click', function () {
          if (!targetMenu) return;

          var isOpen = targetMenu.style.display === 'block';
          targetMenu.style.display = isOpen ? 'none' : 'block';
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // unstick the header for product page
  document.addEventListener('DOMContentLoaded', function () {
    Site.unstickOrRestickHeader();
  });

  } catch(e) { console.error(e); }
})();
})();
